import { useOutletContext } from 'react-router-dom'
import { Ocorrencia } from 'service/api'

export function useOcorrenciasOutletContext() {
    return useOutletContext<{ data?: Ocorrencia[] }>()
}
